<section class="content">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <a
              [routerLink]="['/admin-list/register']"
              class="btn btn-info float-right mb-3"
              >New Admin</a
            >
            <table 
              datatable 
              [dtOptions]="dtOptions"
              [dtTrigger]="dtTrigger" 
              class="row-border hover"
            >
              <thead>
                <tr>
                  <th>S. No.</th>
                  <th>Admin Name</th>
                  <th>Email</th>
                  <th>Mobile No.</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody *ngIf="allAdmin?.length != 0">
                <tr *ngFor="let admin of allAdmin; let i = index">
                  <td>{{ i + 1 }}</td>
                  <td>{{ admin.firstname | titlecase }} {{ admin.lastname | titlecase }}</td>
                  <td>{{ admin.email }}</td>
                  <td>{{ admin.mobile }}</td>
                  <td *ngIf="admin.status === 'active'">Active</td>
                   <td *ngIf="admin.status !== 'active'">Inactive</td>
                  <td>
                    <div class="btn-group">
                      <button 
                        type="button" 
                        class="btn btn-info"
                        routerLink="/admin-list/edit-admin/{{ admin._id }}"
                      ><i class="fas fa-pen"></i></button>
                      <button 
                        *ngIf="admin.status === 'active'"
                        type="button" 
                        class="btn btn-success"
                        (click)="changeStaus(admin._id, admin.status)"
                      ><i class="far fa-check-circle"></i></button>
                      <button 
                        *ngIf="admin.status !== 'active'"
                        type="button" 
                        class="btn btn-danger"
                        (click)="changeStaus(admin._id, admin.status)"
                      ><i class="fas fa-ban"></i></button>
                    </div>
                  </td>
                </tr>
              </tbody>
              <tbody *ngIf="allAdmin?.length == 0">
                <tr>
                  <td colspan="3" class="no-data-available">No data!</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </section>
  